import React, { useEffect, useState } from "react";
import { Autocomplete, Box, Stack, TextField } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import { getAllAssignedKra } from "../../../../../redux/features/appraisalSlice";
import GlobalDatagrid from "../../../../../components/mui/DataGrid/GlobalDatagrid";
import ToolTip from "../../../../../components/ToolTip/ToolTip";
import { getAllUsersNew } from "../../../../../redux/features/generalSlice";
import TagUserlibrary from "./TagKraUser";
import DeleteQuarter from "../../../quarterManagement/DeleteQuarter";
import DeleteAssignedKra from "./DeleteAssignedLibrary";
import EditWeightage from "./EditWeightage";

const KraAllView = () => {
  const dispatch = useDispatch();
  const { paginationData } = useSelector((state) => state.globalDataGrid);
  const { alltaggedkra, loading } = useSelector((state) => state.appraisal);
  const { allUsers } = useSelector((state) => state.general);
  const { gridSize, pageNum, rowData, openAnchor, search } = paginationData;
  const [selectedUsers, setSelectedUsers] = useState("");

  const [value, setValue] = useState(dayjs());

  const data = {
    type: "kra",
    userID: selectedUsers?.userID || "",
    limit: gridSize,
    page: pageNum,
    search: search,
  };

  useEffect(() => {
    if (pageNum) {
      dispatch(getAllAssignedKra(data));
      dispatch(getAllUsersNew());
    }
  }, [pageNum, gridSize, selectedUsers, search]);

  const Kra_Table_Head = [
    {
      field: "sl_no",
      headerName: "Sl No",
    },
    {
      field: "userName",
      headerName: "Employee",
      width: 250,
    },
    {
      field: "libraryName",
      headerName: "KRA",
      width: 250,
      renderCell: (params) => {
        return (
          <ToolTip
            expand={params.row.libraryName}
            content={params.row.libraryName}
          />
        );
      },
    },
    {
      field: "appraisal_weightage",
      headerName: "Weightage (%)",
      width: 200,
    },
    {
      field: "delete",
      headerName: "Action",
      width: 200,
      renderCell: (params) => {
        return (
          <Stack direction={"row"} spacing={2}>
            <EditWeightage
              dispatchData={data}
              userID={params.row.appraisal_user_id}
              weightage={params.row.appraisal_weightage}
              library={params.row.libraryName}
              libraryId={params.row.appraisal_library_id}
            />
            <DeleteAssignedKra
              id={params.row.appraisal_assignment_id}
              data={data}
            />
          </Stack>
        );
      },
    },
  ];

  const handleusertype = (event, newValue) => {
    setSelectedUsers(newValue);
  };

  return (
    <Box sx={{ width: "100%", padding: 0 }}>
      <Box
        sx={{
          p: 2,
          display: "flex",
          alignItems: { xs: "flex-start", sm: "center" },
          justifyContent: "space-between",
          flexDirection: { xs: "column", sm: "row" },
        }}
      >
        <Autocomplete
          sx={{
            width: {
              xs: "100%",
              sm: "40%",
            },
            mb: 1,
          }}
          size="medium"
          name="Employees"
          options={allUsers}
          value={selectedUsers}
          onChange={handleusertype}
          getOptionLabel={(option) => option.name ?? ""}
          isOptionEqualToValue={(option, value) =>
            option.userID === value.userID
          }
          renderInput={(params) => (
            <TextField
              disabled
              fullWidth
              autoComplete="off"
              {...params}
              label="Employee"
            />
          )}
        />
        <Box>
          <TagUserlibrary dispatchData={data} library={"kra"} />
        </Box>
      </Box>
      <GlobalDatagrid
        tableHead={Kra_Table_Head}
        rows={alltaggedkra?.data}
        meta={alltaggedkra?.meta?.totalRecords || 0}
        loading={loading}
        rowUniqueId="sl_no"
        rowClick={false}
      />
    </Box>
  );
};

export default KraAllView;
